import { useEffect, useState } from 'react'
import { useAuth } from '../context/AuthContext'
import Login from "./Login"
import axios from 'axios'
import "./Profile.css"
import Navbar from './Navbar'


const Profile = () => {
  const { user, logout, userToken } = useAuth()
  const [message, setMessage] = useState(null)
  const [updateData, setUpdateData] = useState({
    email: "",
    name: "",
    phone: "",
  })
  useEffect(() => {
    if (user) {
      setUpdateData({
        email: user.email,
        name: user.name,
        phone: user.phone,
      })
    }
  }, [user])

  const handleChangeInput = (e) => {
    const {name, value} = e.target

    setUpdateData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const handleChangePassword = async () => {
    if (user) {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/forgot-password`, {
          email: user.email
        })
        setMessage(response.data.message)
      } catch (err) {
        setMessage(err.response?.data?.message)
      }
    }
  }

    useEffect(() => {
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      scrollToTop()
    }, [])

    
  const handleUpdateProfile = async (e) => {
    e.preventDefault()

    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/users/update-profile`, {
        name: updateData.name, email: updateData.email, phone: updateData.phone, userId: user._id,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`
        }
      },)
      setMessage(response.data.message)
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    } catch (err) {
      setMessage(err.response?.data?.message)
    }
  }

  if (!user) {
    return <Login /> // Pokud profil ještě není dostupný, zobrazíme hlášku
  }

  return (
    <div>
      <Navbar />
      <div className="profile-container">
      <h2>Profil uživatele</h2>
      <form onSubmit={handleUpdateProfile}>
        <div className="form-group">
          <h4>Jméno</h4>
          <input 
            type="text"
            name="name"
            placeholder={updateData.name}
            onChange={handleChangeInput}
            className="profile-input"
          />
        </div>
        <div className="form-group">
          <h4>Telefon</h4>
          <input 
            type="text"
            name="phone"
            placeholder={updateData.phone}
            onChange={handleChangeInput}
            className="profile-input"
          />
        </div>
        <div className="form-group">
          <h4>Email</h4>          
          <input 
            type="email"
            name="email"
            placeholder={updateData.email}
            onChange={handleChangeInput}
            className="profile-input"
          />
        </div>
        <button type="submit" className="profile-update-button">Upravit profil</button>
      </form>

      <div>
        <button onClick={handleChangePassword}>Změnit heslo</button>
        {message && <p className="message">{message}</p>}
      </div>
      <button onClick={logout}>Odhlásit se</button>
      
    </div>
    </div>
  )
}

export default Profile